export enum ProductRecoType {
  topSeller = "top-seller",
  recentlyViewed = "recently-viewed",
  campaignSRP = "campaign-SRP",
  campaignPDP = "campaign-PDP",
  fccGap = "fcc",
}
